import { Fragment, useMemo, useState } from "react";

import { Element, useNode } from "@craftjs/core";
import { debounce } from "lodash";
import { SquareChartGantt } from "lucide-react";

import { define } from "@/components/builder/utils";

import { FormLoaderBlock } from "..";
import { useModuleMetadata } from "../../utils/tailwindConfig/hooks";
import BasePreview from "../base";

import { FormProvider, useFormContext } from "./context";

function FormPreview() {
  const { formId: { value: formId } } = useFormContext()
  useModuleMetadata('session', true)

  return <BasePreview>
    <div>
      <Element
        id={`form-${formId}`}
        is={FormLoaderBlock}
      />
    </div>
  </BasePreview>
}

function FormWrapper({ children }) {
  const [_, setFormContainerId] = useState(null)
  const { store: { actions, query: { node } } } = useNode()

  const handleChangeContainer = useMemo(() => debounce(formContainerId => {
    setFormContainerId(prevFormContainerId => {
      if (prevFormContainerId && prevFormContainerId !== formContainerId) {
        const prevNode = node(prevFormContainerId)
        if (prevNode?.isDeletable()) {
          actions.delete(prevFormContainerId)
        }
      }
      return formContainerId
    })
  }, 300), [actions, node])

  return <FormProvider setNodeId={handleChangeContainer}>
    {children}
  </FormProvider>
}

export default define('form', FormPreview, Fragment)
  .wrap(FormWrapper)
  .palete(<SquareChartGantt size={20} />, 'Form', 'Embedded')
  .level('site')
  .build()
